import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/browser";
import EnvService from "./infra/envs/Env.service";

try {
    Sentry.init({
        dsn: EnvService.sentryDsn,
        environment: EnvService.sentryEnvironment,
        enabled: Boolean(EnvService.sentryDsn),
        integrations: [
            new Sentry.Integrations.Breadcrumbs({
                console: false,
            }),
        ],
    });
} catch (error) {
    console.error("Sentry initialization failed:", error);
}

ReactDOM.render(<App />, document.getElementById("app"));
